import type { SkTourLabels } from '@mercadoni/stark-ui';

import { translateNow } from '../core/services/i18n/translate-now';

/**
 * Navigation labels of every guided tour, read on each `start()` by `provideSkTour({ labels })`
 * so a language switch applies to the next tour. Needs the `onboarding/tour` catalog loaded,
 * which `WhatsNewVisibilityService` does before any release (and its tour) can be shown.
 *
 * @returns The Next, Back, Finish and Close labels in the active language.
 */
export function tourLabels(): SkTourLabels {
  return {
    next: translateNow('onboardingTour.next'),
    prev: translateNow('onboardingTour.prev'),
    done: translateNow('onboardingTour.done'),
    skip: translateNow('onboardingTour.skip'),
  };
}
